import {
	preferenceStorageKey,
	readLocalPreference,
	removeLocalPreference,
	writeLocalPreference,
} from "./localPreference.js";

const STORAGE_KEY = preferenceStorageKey("lastActiveContext");

/** Sentinel `legalEntityId` meaning "explicitly viewing the whole domain," not "nothing chosen yet". */
export const ALL_LEGAL_ENTITIES = "all";

/** Sentinel `companyDomainId` meaning "explicitly viewing all domains" (superadmin-only). */
export const ALL_COMPANY_DOMAINS = "all";

export type LastActiveContext = {
	companyDomainId: string;
	legalEntityId?: string;
};

export const readLastActiveContext = (): LastActiveContext | undefined => {
	const entry = readLocalPreference<LastActiveContext | null>(STORAGE_KEY);
	if (!entry?.value || typeof entry.value.companyDomainId !== "string") {
		return undefined;
	}
	return entry.value;
};

export const writeLastActiveContext = (context: LastActiveContext): void => {
	writeLocalPreference(STORAGE_KEY, context);
};

export const clearLastActiveContext = (): void => {
	removeLocalPreference(STORAGE_KEY);
};

export const isLastActiveContext = (
	value: unknown,
): value is LastActiveContext | null => {
	if (value === null) {
		return true;
	}
	if (typeof value !== "object") {
		return false;
	}
	const candidate = value as {
		companyDomainId?: unknown;
		legalEntityId?: unknown;
	};
	return (
		typeof candidate.companyDomainId === "string" &&
		(candidate.legalEntityId === undefined ||
			typeof candidate.legalEntityId === "string")
	);
};

export const sameLastActiveContext = (
	a: LastActiveContext | null,
	b: LastActiveContext | null,
) =>
	a?.companyDomainId === b?.companyDomainId &&
	a?.legalEntityId === b?.legalEntityId;
